import { Link } from "@tanstack/react-router";

import ChevronLeftIcon from "@/assets/icons/chevron-left.svg?react";

import { Button } from "./ui/button";

interface BackButtonProps {
  backRef?: string;
  backText?: string;
  children?: React.ReactNode;
}

export default function BackButton({ backRef, backText, children }: Readonly<BackButtonProps>) {
  return (
    <Button asChild variant="link" className="px-0">
      <Link to={backRef ?? ".."}>
        <ChevronLeftIcon className="size-6 rtl:rotate-180" />
        <span className="text-(--color-text-color-text-gray) capitalize">
          {children ?? backText}
        </span>
      </Link>
    </Button>
  );
}
